// @flow
import * as React from 'react';
import {capitalize} from 'lodash';
import Box from 'sail/Box';
import Group from 'sail/Group';
import {BodyAlt} from 'sail/Text';
import Select, {SelectOption} from 'sail/Select';

import {ICONS} from '../../OverviewDiagram/OverviewDiagramIconNode';

type SetNodeIconProps = {|
  value: string,
  onChange: (string) => void,
|};
// Renders a dropdown for overview diagram nodes to select an icon
export const SetNodeIcon = ({value, onChange}: SetNodeIconProps) => {
  return (
    <Group spacing={4}>
      <label htmlFor="nodeIcon">
        <BodyAlt>Icon</BodyAlt>
      </label>
      <Box>
        <Select id="nodeIcon" onChange={onChange} value={value}>
          <SelectOption key="none" label={'None'} value={''} />
          {Object.keys(ICONS)
            .sort()
            .map((i) => (
              <SelectOption key={i} label={capitalize(i)} value={i} />
            ))}
        </Select>
      </Box>
    </Group>
  );
};
